import React from "react";
import { Link } from "react-router-dom";
import ClassNames from "classnames";
import Highlighter from "react-highlight-words";
import Tooltip from "../Tooltip/Tooltip";
import SidebarItemActions from "./SidebarItemActions";
import { getDataAnalyticsProps } from "../../../utils/UserAnalyticsUtils";
import type { SidebarSubItem } from "./Sidebar";

export interface SidebarItemProps {
  item: SidebarSubItem;
  searchValue: string;
  isActive: boolean;
  "data-testid": string;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  item,
  searchValue,
  isActive,
  "data-testid": dataTestId,
}) => {
  return (
    <li
      className={ClassNames("sidebar-item-row", {
        "sidebar-item-row--active": isActive,
      })}
    >
      <Link
        to={item.path}
        className={ClassNames("sidebar-item", {
          "sidebar-item--active": isActive,
        })}
        data-testid={item.dataTestId ?? `${dataTestId}-item-${item.title}`}
        {...getDataAnalyticsProps(item)}
      >
        {!!item.icon && (
          <Tooltip content={item.iconTooltip} placement="top">
            <i
              className={`seem-icon sidebar-item-icon ${item.icon}`}
              role={item.iconTooltip ? "img" : undefined}
              aria-label={item.iconTooltip}
            />
          </Tooltip>
        )}
        <Tooltip content={item.title} placement="top">
          <span className="sidebar-item-label">
            {searchValue ? (
              <Highlighter
                highlightClassName="sidebar-item-highlight"
                searchWords={[searchValue]}
                autoEscape
                textToHighlight={item.title}
              />
            ) : (
              item.title
            )}
          </span>
        </Tooltip>
      </Link>
      {!!item.actions?.length && (
        <SidebarItemActions
          actions={item.actions}
          isActive={isActive}
          title={item.title}
          data-testid={dataTestId}
        />
      )}
    </li>
  );
};

export default SidebarItem;
